import type { SxProps, Theme } from "@mui/material";

export const pageContainerSx: SxProps<Theme> = { mt: 11, mx: 3 };

export const pageContainerErrorSx: SxProps<Theme> = {
  ...pageContainerSx,
  mb: 2,
};
